import { RootState } from "@/app/stores"
import { getOemGroups, getPartners, getStores, IPartner } from "@/shared/api/partners"
import { IOEMGroup, IPartnerStore } from "@/shared/api/partners/types"
import { ErrorType } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

export const fetchPartners = createAsyncThunk<
    IPartner[],
    void,
    { state: RootState }
>('partners/fetchPartners', async(_, thunkAPI) => {
    try {
        const data = await getPartners()
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchStores = createAsyncThunk<
    {[key: string]: IPartnerStore[]},
    void,
    { state: RootState }
>('partners/fetchStores', async(_, thunkAPI) => {
    try {
        const data = await getStores()
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchOEMGroups = createAsyncThunk<
    IOEMGroup[],
    void,
    { state: RootState }
>('partners/fetchOEMGroups', async(_, thunkAPI) => {
    try {
        const data = await getOemGroups()
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})